'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _groupBy = require('lodash/groupBy');

var _groupBy2 = _interopRequireDefault(_groupBy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Handles a single unit of work on the database backend.
 */
var Transaction = function () {
    function Transaction() {
        (0, _classCallCheck3.default)(this, Transaction);

        this.updates = [];
        this.updatesByModelName = {};

        this.meta = {};
        this.onCloseCallbacks = [];
    }

    (0, _createClass3.default)(Transaction, [{
        key: 'getUpdatesFor',
        value: function getUpdatesFor(modelClass) {
            var modelName = modelClass.modelName;
            if (!this.updatesByModelName.hasOwnProperty(modelName)) {
                return [];
            }

            return this.updatesByModelName[modelName].filter(function (update) {
                return !update.applied;
            }).map(function (update) {
                return update.update;
            });
        }
    }, {
        key: 'getUnappliedUpdatesByModel',
        value: function getUnappliedUpdatesByModel() {
            var unappliedUpdates = this.updates.filter(function (update) {
                return !update.applied;
            }).map(function (update) {
                return update.update;
            });
            if (unappliedUpdates.length) {
                return (0, _groupBy2.default)(unappliedUpdates, 'meta.name');
            }
            return null;
        }
    }, {
        key: 'markApplied',
        value: function markApplied(modelClass) {
            var modelName = modelClass.modelName;
            this.updatesByModelName[modelName].forEach(function (update) {
                update.applied = true; // eslint-disable-line no-param-reassign
            });
        }
    }, {
        key: 'addUpdate',
        value: function addUpdate(_update) {
            var update = { update: _update, applied: false };
            this.updates.push(update);
            var modelName = _update.meta.name;
            if (this.updatesByModelName.hasOwnProperty(modelName)) {
                this.updatesByModelName[modelName].push(update);
            } else {
                this.updatesByModelName[modelName] = [update];
            }
        }
    }, {
        key: 'addUpdates',
        value: function addUpdates(updates) {
            var _this = this;

            updates.forEach(function (update) {
                return _this.addUpdate(update);
            });
        }
    }, {
        key: 'onClose',
        value: function onClose(fn) {
            this.onCloseCallbacks.push(fn);
        }
    }, {
        key: 'close',
        value: function close() {
            var _this2 = this;

            this.onCloseCallbacks.forEach(function (cb) {
                return cb.call(null, _this2);
            });
        }
    }]);
    return Transaction;
}();

exports.default = Transaction;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-orm/lib/Transaction.js
 ** module id = 555
 ** module chunks = 0
 **/